import { Film, Link2, FileSearch } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SET_IMG =
  "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxmaWxtJTIwc2V0JTIwcHJvZHVjdGlvbiUyMGNhbWVyYXxlbnwwfHx8fDE3ODc3NDA3OTN8MA&ixlib=rb-4.1.0&q=85";

const PILLARS = [
  {
    icon: Film,
    title: "Industry Specialist Focus",
    copy: "Financial control designed around Film, OTT, Television and Media production workflows.",
  },
  {
    icon: Link2,
    title: "End-to-End Control",
    copy: "Commercial, audit and accounting connected from planning through final cost.",
  },
  {
    icon: FileSearch,
    title: "Transparent Processes",
    copy: "Structured documentation, reconciliation and reporting at every stage.",
  },
];

export default function WhyVeritas() {
  return (
    <section id="why" data-testid="why-section" className="relative border-t border-white/10 py-24 md:py-32">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-16 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="mb-4 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
              <span className="h-px w-10 bg-[#B79045]" /> Why Choose Veritas
            </p>
            <h2 className="font-display text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              Built for the Business of{" "}
              <em className="italic text-[#D4AF37]">Entertainment.</em>
            </h2>
            <p className="mt-6 max-w-xl text-sm leading-relaxed text-neutral-400 md:text-base">
              Film and media productions are complex. Our systems are designed
              around the pace, scale and unique financial requirements of the
              industry.
            </p>
          </Reveal>

          <div className="mt-14">
            {PILLARS.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08}>
                <div
                  data-testid={`pillar-${i + 1}`}
                  className="group flex items-start gap-6 border-t border-white/10 py-8 transition-colors duration-500 last:border-b hover:bg-[#0f0d09]"
                >
                  <p.icon
                    size={26}
                    strokeWidth={1.5}
                    className="mt-1 shrink-0 text-[#B79045] transition-transform duration-500 group-hover:scale-110"
                  />
                  <div>
                    <h3 className="font-display text-2xl font-medium text-neutral-100 md:text-3xl">
                      {p.title}
                    </h3>
                    <p className="mt-2 max-w-lg text-sm leading-relaxed text-neutral-400">
                      {p.copy}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.2} className="lg:sticky lg:top-32">
            <div className="relative overflow-hidden">
              <img
                src={SET_IMG}
                alt="Film set in production"
                loading="lazy"
                className="h-[420px] w-full object-cover md:h-[560px]"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "radial-gradient(ellipse at 50% 20%, transparent 25%, rgba(5,5,5,0.8) 100%)",
                }}
              />
              <span className="absolute bottom-4 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-400">
                Fig. 02 — On Set
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
